import {
  UnorderedListOutlined
} from '@ant-design/icons';
import { Button, Descriptions, Tabs } from 'antd';
import CommonCard from 'commons/Layout/CommonCard';
import { openNotification } from 'commons/Notifications';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FaMap } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ServiceAirTree from 'services/airTree';
import { FormatDate } from 'utils/helpers/date_helpers';
import CommonTable from '../../commons/CommonTable';
import { AirTreeProjectTableColumns } from './components/tableColumns';
import OlMap from 'ol/Map';
import OlLayerTile from 'ol/layer/Tile';
import OlSourceOsm from 'ol/source/OSM';
import OlView from 'ol/View';
import { fromLonLat } from 'ol/proj';
import { MapComponent } from '@terrestris/react-geo';
import ServiceLocations from 'services/locations';
import { Feature, Overlay } from 'ol';
import VectorSource from 'ol/source/Vector';
import { bbox as bboxStrategy } from 'ol/loadingstrategy';
import VectorLayer from 'ol/layer/Vector';
import { Circle, Fill, Stroke, Style } from 'ol/style';
import { Point } from 'ol/geom';
import ReactDOM from 'react-dom';
import CommonOverlayComponent from 'commons/CommonOverlayComponent';
import ServiceGeoServer from 'services/geoServer';
import GeoJSON from 'ol/format/GeoJSON';

const { TabPane } = Tabs;

const latlon = [12.4963655, 41.9027835];

const center = fromLonLat(latlon);

const AirtreePublicProjectList = (props) => {
  const airTreeProjectsTable = useRef(undefined);
  let navigate = useNavigate();
  const [map, setMap] = useState(null);
  const [regioni, setRegioni] = useState([])
  const [projects, setProjects] = useState([])
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [selectedProject, setSelectedProject] = useState(null)
  const [regionsVectorLayer, setRegionsVectorLayer] = useState(null);

  useMemo(() => {

    // Set regioni
    ServiceLocations.listRegioni({}).then(response => {
      const responseMap = response?.data?.map(regione => {
        return { value: regione?.id, text: regione?.regione }
      })
      setRegioni(responseMap)
    })

    // Set projects
    ServiceAirTree.listProjects({
      pagination: false,
      expand: "createdBy,regione",
      search: { type: 1, status: 2, public: true }
    }).then(res => setProjects(res?.data))

    // Get Regions Vector
    ServiceGeoServer.getItalianRegionsShape().then((wfsRegions) => {

      const vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(wfsRegions),
        strategy: bboxStrategy,
      });

      const vectorProject = new VectorLayer({
        source: vectorSource,
        // @ts-ignore
        name: 'Regioni',
        style: new Style({
          fill: new Fill({
            color: 'rgba(94, 176, 44, 0.1)',
          }),
          stroke: new Stroke({
            color: 'rgba(94, 176, 44, 1.0)',
            width: 2,
          }),
        }),
      });
      setRegionsVectorLayer(vectorProject)
    });
  }, [])

  useEffect(() => {
    if (projects && regionsVectorLayer) {

      let markers = projects?.map(prj => {

        return new Feature({
          geometry: new Point(
            fromLonLat([prj?.centroid_lng, prj?.centroid_lat])
          ),
          id: prj?.id,
          name: prj?.name,
          simulation_date_start: prj?.simulation_date_start,
          simulation_date_end: prj?.simulation_date_end,
        })
      });

      const vectorSource = new VectorSource({
        features: markers,
        strategy: bboxStrategy,
      });


      const markerVectorLayer = new VectorLayer({
        source: vectorSource,
        style: function (feature) {
          return new Style({
            image: new Circle({
              fill: new Fill({
                color: 'rgba(255, 55, 10, 0.7)',
              }),
              stroke: new Stroke({
                color: 'rgba(255, 55, 10, 1)',
              }),
              radius: 6,
            }),
          });
        }
      });

      // Set map
      setMap(new OlMap({
        layers: [
          new OlLayerTile({
            //name: 'OSM',
            source: new OlSourceOsm()
          }),
          markerVectorLayer,
          regionsVectorLayer
        ],
        view: new OlView({
          //projection: 'EPSG:4326',
          center: center,
          zoom: 7
        })
      }));
    }
  }, [projects, regionsVectorLayer])


  if (map) {
    map.on('click', function (e) {
      const feature = map.forEachFeatureAtPixel(e.pixel,
        function (feat) {
          setDrawerVisible(true)
          setSelectedProject(feat)
        });
    });
  }

  const viewRecord = (record: any = null) => {
    if (record) {
      navigate("/airtree-view/" + record?.id, { replace: true })
    }
  };

  // Clone record
  const cloneRecord = async (record) => {

    if (record) {

      ServiceAirTree.clone(record?.id)
        .then((success) => {
          openNotification({
            message: 'OK',
            description: 'Progetto duplicato correttamente',
            type: 'success',
          });
          navigate("/airtree-list/", { replace: true })
        })
    }
  };

  return (
    <CommonCard title={<h2>AirTree: Lista progetti pubblici</h2>}>

      <Tabs defaultActiveKey="1">
        <TabPane
          tab={
            <span>
              <UnorderedListOutlined />
              Visualizza lista
            </span>
          }
          key="1"
        >
          <CommonTable
            ref={airTreeProjectsTable}
            title="Lista progetti"
            scroll={{ x: 2400 }}
            debug={false}
            columns={AirTreeProjectTableColumns({ viewRecord, regioni, public: true, cloneRecord })}
            service={(paginationParams, filters) => {
              if (filters?.created_at) {
                filters.created_at = FormatDate(filters.created_at, 'YYYY-MM-DD');
              }
              if (filters?.simulation_date_start) {
                filters.simulation_date_start = FormatDate(filters.simulation_date_start, 'YYYY-MM-DD');
              }
              if (filters?.simulation_date_end) {
                filters.simulation_date_end = FormatDate(filters.simulation_date_end, 'YYYY-MM-DD');
              }
              filters.type = 1;
              filters.status = 2;
              filters.public = true;
              return ServiceAirTree.listProjects({
                pagination: true,
                paginationParams,
                expand: "createdBy,regione",
                search: filters
              })
            }
            }
            pageSize={20}
            searchAllColumns={true}
            sortAllColumns={true}
          />
        </TabPane>
        <TabPane
          tab={
            <span>
              <FaMap style={{ marginRight: '8px' }} />
              Visualizza mappa
            </span>
          }
          key="2"
        >
          {map &&
            <MapComponent
              map={map}
              style={{
                width: '100%',
                height: '80vh'
              }}
            />
          }
        </TabPane>
      </Tabs>
      <CommonOverlayComponent
        title={`Scheda progetto`}
        //onSubmit={onSubmit}
        type="modal"
        destroyOnClose={true}
        //permission={DisabledFields}
        visible={drawerVisible}
        width={'40%'}
        okText="Conferma e Salva"
        onCancel={() => setDrawerVisible(false)}
        buttons={[
          <Button
            type="primary"
            onClick={() => navigate(`/airtree-view/${selectedProject?.get('id')}`, { replace: true })}
          >
            Visualizza progetto
          </Button>,
        ]
        }
      // formsOpts={{
      //   debug: false,
      //   fields: AirTreeProjectFormFields,
      //   //ref: Form,
      //   hideSubmit: true,
      //   initialValues: currentRecord || undefined,
      // }}
      >
        <Descriptions
          bordered
          //title={<Title level={3} type="secondary">ID geometria: {simulationResponse?.uuid}</Title>}
          size={'small'}
          style={{ paddingBottom: '20px' }}
          column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
        //extra={<Button type="primary">Edit</Button>}
        >
          <Descriptions.Item label="Nome progetto">{selectedProject?.get('name')}</Descriptions.Item>
          <Descriptions.Item label="Data inizio simulazione">{FormatDate(selectedProject?.get('simulation_date_start'))}</Descriptions.Item>
          <Descriptions.Item label="Data fine simulazione">{FormatDate(selectedProject?.get('simulation_date_end'))}</Descriptions.Item>
        </Descriptions>
      </CommonOverlayComponent>
    </CommonCard>
  );
}

export default AirtreePublicProjectList;
